import { Injectable } from '@angular/core';
import { PostalCodeOutput, ZipCodeErrorMessage } from './model/zipcode-types';
import { Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class CsbZipcodeService {
    constructor(private _httpClient: HttpClient) {}

    lookup(url: string): Observable<PostalCodeOutput> {
        return this._httpClient.get<PostalCodeOutput>(url);
    }

    getErrorMessage(err: HttpErrorResponse) {
        let errorMessage;

        switch (err.status) {
            case 404:
                errorMessage = ZipCodeErrorMessage.NOT_FOUND;
                break;
            default:
                errorMessage = err.message;
                break;
        }

        return errorMessage;
    }
}
